@if (isLoadingLabelVisible) {
  <div id="loaderModal" class="modal">
    <div class="modal-content">
      <p>Please wait, while quiz questions are loaded.</p>
    </div>
  </div>
}
<div class="container my-3 mx-1 ">
  @if (quizName != '') {
    <div class="h5">
      {{quizName}}
      @if (questions.length > 0) {
        <div class="btn-group">
          <button class="btn btn-outline-secondary" type="button" (click)="checkAnswers()" data-bs-toggle="tooltip" data-bs-placement="top" title="Check your answers" data-bs-delay="{show: 1000}">
            <i class="bi bi-send-fill"></i>
          </button>
          @if (hideAnswered == true) {
            <button class="btn btn-outline-secondary" type="button" (click)="toggleHideAnswered()" data-bs-toggle="tooltip" data-bs-placement="top" title="Hide answered questions" data-bs-delay="{show: 1000}">
              <i class="bi bi-eye-slash-fill pointer"></i>
            </button>
          }
          @if (hideAnswered == false) {
            <button class="btn btn-outline-secondary" type="button" (click)="toggleHideAnswered()" data-bs-toggle="tooltip" data-bs-placement="top" title="Show answered questions" data-bs-delay="{show: 1000}">
              <i class="bi bi-eye-fill"></i>
            </button>
          }
        </div>
      }
    </div>
    <div>
      Questions: {{questions.length}}
    </div>
  }
  @if (quizDescription != '') {
    <div class="lead my-1">
      <p [innerHTML]="quizDescription">
      </p>
    </div>
  }
  @if (showResult == false) {
    <div class="lead my-1" >
      Answered questions {{answeredQuestions}} ({{100*(answeredQuestions / questions.length) | number:'1.0-0'}}%).
    </div>
  }
  @if (showResult == true) {
    <div class="lead my-1" #topOfPage>
      Your score in the test is {{goodAnswers}} correct answers on {{questions.length}} questions ({{100*(goodAnswers / questions.length) | number:'1.0-0'}}%).
    </div>
  }
</div>
@for (q of questions; track q; let qIndex = $index) {
  <div class="my-2 mx-2" [ngClass]="{'d-none': hideAnswered && q.userSelected != -1}">
    <form>
      <fieldset>
        <legend class="my-2 lead" style="line-height: 2rem;">
          {{qIndex+1}}.
          {{q.question}}
        </legend>
        @for (a of q.answers; track a; let i = $index) {
          <div class="form-check mx-2 my-3"
           [ngClass]="{'text-success': i === q.correctAnswer && showResult, 
                       'text-danger': i !== q.correctAnswer && q.userSelected === i && showResult}">
            <input class="form-check-input" type="radio" name="answer{{qIndex}}" id="answer{{qIndex}}-{{i}}" [value]="i" (click)="onSelect(qIndex, i)">
            <label class="form-check-label" for="answer{{qIndex}}-{{i}}" (click)="checkAnswer()" >
              {{a}}
            </label>
          </div>
        }
      </fieldset>
    </form>
    @if (showResult == true && q.explanation && q.explanation.length > 0) {
      <div>
        <small [innerHTML]="q.explanation">
        </small>
      </div>
    }
  </div>
}
@if (questions.length == 0) {
  <div class="my-4 mx-1">
    No questions found. You can edit quizes and questions in administration panel.
  </div>
}
<div class="btn-group">
  @if (questions.length > 0) {
    <button class="btn btn-outline-secondary" type="button" (click)="checkAnswers()" data-bs-toggle="tooltip" data-bs-placement="top" title="Check your answers" data-bs-delay="{show: 1000}">
      <i class="bi bi-send-fill"></i>
    </button>
  }
</div>